import { httpClient } from '@/src/@core/lib/httpClient'

export interface IncompleteJob {
  id: number
  jobId: number
  restaurantId: number
  restaurantName: string
  channelId: number
  channelName: string
  groupId: number | null
  groupName: string | null
  description: string
  status: string
  createdAt: string
  createdBy: number
  CreatedByName: string
  request: string
}

export interface JobResponse {
  data: IncompleteJob[]
  count: number
  loading: boolean
  error: string | null
  meta?: {
    total: number
    from: number
    to: number
    page: string
    pageSize: string
    totalPages: number
    hasNextPage: boolean
    hasPreviousPage: boolean
  }
}

export const jobService = {
  // Get all incomplete jobs
  getIncompleteJobs: async (params?: any): Promise<JobResponse> => {
    try {
      const response = await httpClient.get('/resto365-job/incompleted/all', { params })

      return {
        data: response.data.data || [],
        count: response.data.meta?.total || 0,
        loading: false,
        error: null,
        meta: response.data.meta
      }
    } catch (error: any) {
      return {
        data: [],
        count: 0,
        loading: false,
        error: error.response?.data?.message || 'Failed to fetch incomplete jobs',
        meta: undefined
      }
    }
  },

  // Get incomplete jobs for a specific restaurant
  // GET /resto365-job/incompleted/restaurant/:id → { data: IncompleteJob[] }
  getIncompleteJobsByRestaurant: async (restaurantId: number): Promise<IncompleteJob[]> => {
    try {
      const response = await httpClient.get(`/resto365-job/incompleted/restaurant/${restaurantId}`)

      const data = response.data
      if (Array.isArray(data)) {
        return data
      }
      if (data && Array.isArray(data.data)) {
        return data.data
      }

      return []
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to fetch restaurant incomplete jobs')
    }
  },

  // Mark a specific incomplete job as failed
  markJobAsFailed: async (jobId: number): Promise<any> => {
    try {
      const response = await httpClient.patch(`/resto365-job/mark-failed/${jobId}`)

      return response.data
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to mark job as failed')
    }
  }
}
